import { render, staticRenderFns } from "./App.vue?vue&type=template&id=35806550&scoped=true"
import script from "./App.js?vue&type=script&lang=js&external"
export * from "./App.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=35806550&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35806550",
  null
  
)

export default component.exports